import { render } from "./AttendancePage.vue?vue&type=template&id=ba8156ce"
import script from "./AttendancePage.vue?vue&type=script&lang=js"
export * from "./AttendancePage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__